var map = {
	"./Baking Factory Lazimpat-6629.jpg": 9323,
	"./IMG_9493.jpg": 1873,
	"./IMG_9501.jpg": 5903,
	"./Kiki Salad.png": 9722,
	"./Korean Wings.png": 8167,
	"./Manchow soup.png": 8903,
	"./PerosPizza Thamel-6564.jpg": 1356,
	"./PerosPizza Thamel-6568.jpg": 580,
	"./Trisara Durbarmarg-6547.jpg": 5710,
	"./Trisara Durbarmarg-6555.jpg": 1693,
	"./Trisara-menu-1.png": 7795,
	"./Trisara-menu-2.png": 3593,
	"./Trisara-menu-3.png": 4617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4452;